import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const ExclamationFilled: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[2px] text-white fill-[#FFD324]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 1.6665C14.6025 1.6665 18.3333 5.39734 18.3333 9.99984C18.3351 12.1877 17.4763 14.2885 15.9424 15.8487C14.4085 17.4089 12.3226 18.3032 10.135 18.3387C7.94742 18.3741 5.83362 17.5478 4.25 16.0382C2.66639 14.5285 1.74 12.4566 1.67084 10.2698L1.66667 9.99984L1.67001 9.7665C1.79334 5.27234 5.47501 1.6665 10 1.6665ZM10.0083 12.4998L9.9025 12.5057C9.69996 12.5298 9.51329 12.6273 9.37785 12.7798C9.24241 12.9323 9.1676 13.1292 9.1676 13.3332C9.1676 13.5371 9.24241 13.734 9.37785 13.8865C9.51329 14.039 9.69996 14.1366 9.9025 14.1607L10 14.1665L10.1058 14.1607C10.3084 14.1366 10.4951 14.039 10.6305 13.8865C10.7659 13.734 10.8407 13.5371 10.8407 13.3332C10.8407 13.1292 10.7659 12.9323 10.6305 12.7798C10.4951 12.6273 10.3084 12.5298 10.1058 12.5057L10.0083 12.4998ZM10 5.83317C9.79589 5.8332 9.59889 5.90813 9.44636 6.04377C9.29383 6.1794 9.19639 6.36629 9.1725 6.569L9.16667 6.6665V9.99984L9.1725 10.0973C9.1966 10.2999 9.29413 10.4866 9.44664 10.622C9.59915 10.7574 9.79604 10.8322 10 10.8322C10.204 10.8322 10.4009 10.7574 10.5534 10.622C10.7059 10.4866 10.8034 10.2999 10.8275 10.0973L10.8333 9.99984V6.6665L10.8275 6.569C10.8036 6.36629 10.7062 6.1794 10.5536 6.04377C10.4011 5.90813 10.2041 5.8332 10 5.83317Z"
      fill="#FF4035"
    />
  </svg>
);

export default ExclamationFilled;
